import { IFormField, IFormFieldRenderer, getFractionDigits } from '@migrate/utils/form/form'
import renderPercentage from '@migrate/utils/renderer/Percentage'

export class PercentageRenderer implements IFormFieldRenderer {
  render(field: IFormField) {
    return renderPercentage(field.value, getFractionDigits(field))
  }
}
